var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "price-manual-list d-flex flex-column",
      class: _setup.isMobile ? "ga-6" : "ga-8",
      attrs: { "data-qa": "lpu_page_price_manual" },
    },
    [
      _vm.specialities.length
        ? _c(
            "section",
            {
              staticClass: "d-flex flex-column",
              class: _setup.isMobile ? "ga-4" : "ga-6",
              attrs: { id: "specs", "data-qa": "lpu_page_price_specialities" },
            },
            [
              _c(
                "h2",
                {
                  staticClass: "text--text",
                  class: _setup.isMobile
                    ? "text-h6"
                    : "text-h5 font-weight-medium",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.tStatic("Цены на приём специалистов")) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                _setup.PricesListCard,
                { attrs: { borderless: "" } },
                _vm._l(_vm.specialities, function (item, index) {
                  return _c(
                    "a",
                    {
                      key: _setup.specialityId(item),
                      staticClass:
                        "price-manual-list__row d-flex text-decoration-none rounded-20 pa-4",
                      class: [
                        _setup.isMobile
                          ? "flex-column ga-3"
                          : "align-center ga-5",
                        { "bg-gray-40": index % 2 === 0 },
                      ],
                      attrs: {
                        href: _setup.specialityHref(_setup.specialityId(item)),
                        "data-qa": "lpu_page_price_speciality_item",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "price-manual-list__name text-body-1 primary--text",
                          class: { "flex-grow-1": !_setup.isMobile },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.spec__name) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-subtitle-1 text--text flex-shrink-0",
                          class: { "text-right": !_setup.isMobile },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.specialityPrice(item)) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.categories, function (category) {
        return _c(
          "section",
          {
            key: category.translit,
            staticClass: "d-flex flex-column",
            class: _setup.isMobile ? "ga-4" : "ga-6",
            attrs: {
              id: category.translit,
              "data-qa": "lpu_page_price_category",
            },
          },
          [
            _c(
              "h2",
              {
                staticClass: "text--text",
                class: _setup.isMobile ? "text-h6" : "text-h5",
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.tStatic("Цены на")) +
                    " " +
                    _vm._s(category.name) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            category.url &&
            category.name &&
            !_vm.lpu.has_prices_with_appointment
              ? _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.tStatic("Посмотрите все цены на")) +
                      "\n      "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "text-decoration-underline primary--text",
                      attrs: { href: category.url },
                    },
                    [_vm._v("\n        " + _vm._s(category.name) + "\n      ")]
                  ),
                  _vm._v(
                    "\n      , " +
                      _vm._s(_setup.tStatic("чтобы выбрать лучший вариант")) +
                      ".\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.PriceEquipmentList, {
              attrs: { items: _setup.unwrapList(category.equipments) },
            }),
            _vm._v(" "),
            _vm._l(
              _setup.unwrapList(category.service_types),
              function (serviceType) {
                return _c(
                  "div",
                  {
                    key: serviceType.name || "extra",
                    staticClass: "d-flex flex-column",
                    class: _setup.isMobile ? "ga-3" : "ga-4",
                  },
                  [
                    _c("h3", { staticClass: "text-subtitle-1 text--text" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            serviceType.name || _setup.tStatic("Дополнительно")
                          ) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      _setup.PricesListCard,
                      { attrs: { borderless: "" } },
                      _vm._l(
                        _setup.unwrapList(serviceType.services),
                        function (service, index) {
                          return _c(
                            _setup.serviceHref(service) ? "a" : "div",
                            {
                              key: `${service.name}-${index}`,
                              tag: "component",
                              staticClass:
                                "price-manual-list__row d-flex text-decoration-none rounded-20",
                              class: [
                                _setup.isMobile
                                  ? "flex-column ga-3 pa-4"
                                  : "align-center ga-8 px-4 py-3",
                                { "bg-gray-40": index % 2 === 1 },
                              ],
                              attrs: {
                                href: _setup.serviceHref(service) || undefined,
                                "data-qa": "lpu_page_price_diagnostic_item",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "price-manual-list__name text-body-1 text--text min-w-0",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(service.name) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-subtitle-1 text--text flex-shrink-0",
                                  class: { "text-right": !_setup.isMobile },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.diagnosticPrice(service)) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                )
              }
            ),
          ],
          2
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }